// extracted by mini-css-extract-plugin
export default {"main":"auth_main__yDdNY","form":"auth_form__On2vV","row":"auth_row__QhR-c"};